import * as rq from '@tanstack/react-query';

// import { format } from 'date-fns/fp';
import { type BodyOf, FeApi } from '@/api/fe-api';
import { appConfig } from '@/config';
import { useAuth } from '@/hooks/use-auth';
import { useMe } from '@/hooks/use-me';

import { getMockedStaticData } from '../_mock_data/static-data';
import { type StaticData, StaticDataSchema } from '../entities/static-data';

import { staticDataFromApi } from './mappers/static-data-mapper';

// const dateKey = format('yyyy-mm-dd');

export namespace GetStaticData {
  export const key = (input: Input) => [
    'siteview',
    'static-data',
    input.siteId,
    // TODO: input.date is not used yet, uncomment when it is used
    // dateKey(input.date),
  ];

  export type Input = { siteId: string; date: Date };
  export type Output = StaticData;

  function bodyFromInput(
    input: Input,
  ): BodyOf<typeof FeApi.customerInfosV1SitesStaticDataRetrieve> {
    return {
      accureId: input.siteId,
    };
  }

  export function useQuery(input: Input) {
    const auth = useAuth();
    const me = useMe();

    return rq.useQuery<Output, Error>({
      keepPreviousData: true,
      queryKey: key(input),
      async queryFn(): Promise<StaticData> {
        if (me.config.id === '49') {
          return getMockedStaticData(input.siteId, input.date);
        }

        const accessToken = await auth.getAccessToken();
        const body = bodyFromInput(input);
        const response = await FeApi.customerInfosV1SitesStaticDataRetrieve(
          body,
          {
            baseUrl: `${appConfig.bffUrl}/plex`,
            headers: {
              Authorization: `Bearer ${accessToken}`,
              'x-user-name': me.displayName,
              'x-user-email': me.email,
            },
          },
        );

        if (response.status !== 200) {
          throw new Error('Failed to fetch static data');
        }

        const patchedData = staticDataFromApi(response.data);
        const staticData = await StaticDataSchema.parseAsync(patchedData);

        return staticData;
      },
    });
  }
}
